import { render, staticRenderFns } from "./customerConfig.vue?vue&type=template&id=6174c921&"
import script from "./customerConfig.vue?vue&type=script&lang=js&"
export * from "./customerConfig.vue?vue&type=script&lang=js&"
import style0 from "./customerConfig.vue?vue&type=style&index=0&id=6174c921&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports